import { useFeatureFlag } from '@/integrations/feature-flags/feature-flags';

/**
 * Whether the persistent Nami copilot (bottom-right pill + always-available
 * docked panel with the `home` fallback surface) is on for this user. On when
 * the chat agent is on, so the assistant is summonable from every page, or
 * when `nami-copilot-enabled` rolls the copilot out on its own.
 */
export function useNamiEnabled(): boolean {
  const { enabled: chatEnabled } = useFeatureFlag('chat-agent-enabled', false);
  const { enabled: namiEnabled } = useFeatureFlag(
    'nami-copilot-enabled',
    false,
  );
  return chatEnabled || namiEnabled;
}
